<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >物流&订单管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cBacklogList' }"
          >退款申请审核</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cBacklogDetail' }"
          >退款申请详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>审批操作</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p>退款原因</p>
            <p>{{ dataItem.reasonidstr }}</p>
          </div>
          <div class="block">
            <p><span class="mark">*</span>退款审核状态</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.checkstate"
              >
                <el-radio label="1" style="margin-bottom: 20px">审核中</el-radio>
                <el-radio label="2">审核中（待用户发货收到的商品）</el-radio>
                <el-radio label="3">审核中（已收到退货）</el-radio>
                <el-radio label="4">同意退款</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { encryptstringview } from "../../../api/api";
import { getBacklogDetail, editBacklogState } from "../../../api/shop";
export default {
  name: "cBacklogEdit",
  data() {
    return {
      loading: false,
      id: "",
      dataItem: "",
      formData: {
        checkstate: "",
        orderid: "",
        openid: "",
        id: "",
      },
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getBacklogDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 订单列表
    getBacklogDetail(id) {
      this.loading = true;
      getBacklogDetail({ id }).then((res) => {
        this.dataItem = res;
        this.formData.id = res.id;
        this.formData.openid = res.openid;
        this.formData.orderid = res.orderid;
        this.formData.checkstate = res.checkstate;
        this.loading = false;
      });
    },

    // 保存
    query() {
      let { formData } = this;
      if (formData.checkstate == "") {
        this.$message.warning("请选择退款审核状态");
        return;
      }
      this.loading = true;
      editBacklogState(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>